// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"e1a3e065","453":"39c49806","455":"d269cf10","977":"d2dd7a9b"}[chunkId] + ".chunk.js";
};